"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGISTER = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const auth_1 = require("common/auth");
const Alert_1 = __importDefault(require("react-bootstrap/Alert"));
const components_1 = require("utils/components");
const __1 = require("..");
const schemaComponents_1 = require("@/schemaComponents");
const standard_1 = require("react-hook-schema/standard");
require("./register.scss");
const hooks_1 = require("common/hooks");
const index_1 = require("../../index");
exports.REGISTER = __1.ADMIN.sub("/register", Register);
function Register() {
    const { formatMessage } = (0, hooks_1.useFormatter)();
    const [signInError, setSignInError] = (0, react_1.useState)(null);
    const [resetPassword] = (0, auth_1.useResetPasswordAdmin)();
    const toast = (0, standard_1.useToast)();
    const error = signInError;
    const parameter = {
        title: "パスワードリセット",
        schema: {
            schemaType: "object",
            properties: [
                {
                    propertyName: "email",
                    title: formatMessage("Field.Email"),
                    schema: { schemaType: "email" },
                },
            ],
        },
        edit: {
            title: "送信",
            handler: (value) => __awaiter(this, void 0, void 0, function* () {
                yield resetPassword({
                    email: value.email,
                    path: (0, index_1.resolveRoute)("LOGIN"),
                });
                console.log("completed");
                yield toast({
                    message: "パスワードリセットのためのメールを送信しました",
                    duration: 3000,
                });
            }),
            confirm: false,
        },
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "consumer-container" },
            react_1.default.createElement("section", { className: "main-section remove-card-border adjust-width" },
                react_1.default.createElement(schemaComponents_1.SchemaFormPage, { data: {}, parameter: parameter }),
                error && (react_1.default.createElement(Alert_1.default, { variant: "danger" },
                    react_1.default.createElement(components_1.ErrorMessage, { error: error }))),
                react_1.default.createElement(react_router_dom_1.Link, { to: (0, index_1.resolveRoute)("LOGIN") }, "\u30ED\u30B0\u30A4\u30F3\u306F\u3053\u3061\u3089")))));
}
exports.default = Register;
